import Backbone from "../../libs/backbone/backbone";
import GenericModel from "./generic.model.ts";

export default GenericModel.extend(
{
    urlRoot : "/api/statistics/queues",
    id : null,
});

